import { apiRequest } from "../../../utils/apiFunction";

export default async function signIn({ authToken, userID, businessEntityId }) {
  const role = sessionStorage.getItem("role");
  const parentState = sessionStorage.getItem("ps");
  const steps = JSON.parse(sessionStorage.getItem("ladder"));
  const activeBrand = sessionStorage.getItem("activeBrand");
  const dashboardState = localStorage.getItem("dashboardState" + activeBrand);

  sessionStorage.setItem("userID", parseInt(userID));
  sessionStorage.setItem("authToken", authToken);
  sessionStorage.setItem("businessEntityId", businessEntityId);

  let permissions = {
    monetization: [
      { ID: "my-billings", page: "My Billing" },
      { ID: "my-campaign", page: "Campaign List" },
      { ID: "brand-details", page: "Brand Details" },
      { ID: "audience-list", page: "Audience List" },
      { ID: "profile-page", page: "Profile Details" },
      { ID: "company-details", page: "Company Details" },
      { ID: "analytics", page: "Analytics" },
      { ID: "channel-setting-page", page: "Channel Agent Setting Page" },
      { ID: "whatsapp-onboarding", page: "whatsApp Onboarding" },
      { ID: "botDetailsPage", page: "Bot Details" },
      { ID: "lead-campaign-page", page: "Lead Campaign Details" },
      { ID: "lead-campaign-list-page", page: "Lead Campaign List" },
      { ID: "lead-campaign-api-page", page: "Lead Campaign API Page" },
    ],

    AGENCY: [
      { ID: "analytics", page: "Analytics" },
      { ID: "agency-dashboard-details", page: "Agency Details" },
      { ID: "company-details", page: "Company Details" },
      { ID: "profile-page", page: "Profile Details" },
      { ID: "brand-details", page: "Brand Details" },
      { ID: "create-brand-empty", page: "Create Brand" },
      { ID: "brands-agency", page: "Brands Agency" },
      { ID: "brand-details", page: "Brand Details" },
    ],
  };

  let userData = {};
  let brands = [];

  if (role === "NORMAL_USER" || role === "AGENCY") {
    const brandsData = await apiRequest({
      url: "/brand?businessEntityId=" + businessEntityId,
      method: "GET",
      authToken: authToken,
    }).then((res) => res.data.data?.parsedBrands);

    brands = getBrands(brandsData);

    userData = await apiRequest({
      url: "/user/info?userId=" + userID,
      method: "GET",
      authToken: authToken,
    }).then((res) => res.data.data);

    if (brands.length > 0) {
      if (!activeBrand) {
        sessionStorage.setItem("activeBrand", brands[0].ID);
      }
    }
  }

  const categories = await apiRequest({
    url: "/brand/getAllBusinessCategories",
    method: "GET",
    authToken: authToken,
  }).then((res) => res.data.data);

  const locations = await apiRequest({
    url: "/getAllCountries",
    method: "GET",
    authToken: authToken,
  }).then((res) => res.data.data);

  const languages = await apiRequest({
    url: "/getAllLanguages",
    method: "GET",
    authToken: authToken,
  }).then((res) => res.data.data);

  if (userData?.page_permissions?.display_credits) {
    permissions["monetization"].push({
      ID: "credit-page",
      page: "Credit Page",
    });
  }

  permissions["monetization"].push({
    ID: "template-list",
    page: "Template list",
  });

  return {
    location: locations,
    authToken: authToken,
    languages: languages,
    categories: categories,
    brands: brands,
    userID: parseInt(userID),
    steps: steps,
    role: role || "",
    parentState: parentState,
    pagePermissions: userData?.page_permissions || {},
    agencyID: userData?.agency?.agency_id || null,
    enabledChannels: userData?.channels || {},
    accessToken: userData?.brand?.cpass_access_token || null,
    agency:
      {
        agencyID: userData?.agency?.agency_id || "",
        agencyName: userData?.agency?.agency_name || "",
        agencyLogo: userData?.agency?.agency_logo || "",
        isAgencyVerified: userData?.agency?.is_agency_verified || "",
      } || {},
    agent: role === "NORMAL_USER" ? userData?.brand?.agents : [],
    isAdminVerified: userData?.user?.is_admin_verified,
    parentBrandVerified: userData.user?.is_parent_brand_verified,
    userData: {
      email: userData.user?.email || "",
      givenName: userData.user?.given_name || "",
      familyName: userData.user?.family_name || "",
      displayName: userData.user?.display_name || "",
      role: userData.user?.role_name || "",
    },
    creditDetails: userData?.credit_details || {},
    dashboardState: role === "NORMAL_USER" ? "monetization" : role,
    dashboardPermissions:
      role === "NORMAL_USER" ? permissions.monetization : permissions[role],
    businessEntityID: userData.brand?.business_entity_id || businessEntityId,
    activeBrand: !!brands.find(
      (brand) => parseInt(brand.ID) === parseInt(activeBrand)
    )
      ? brands.find((brand) => parseInt(brand.ID) === parseInt(activeBrand))
      : brands.length > 0
      ? brands[0]
      : {
          ID: "",
          about: "",
          brandName: "",
          logo: "",
          languages: [],
          locations: [],
          category: [],
          mau: "",
          onlineStore: "",
          website: "",
          socialMedia: {},
          brandType: "",
        },

    brandType: !!brands.find(
      (brand) => parseInt(brand.ID) === parseInt(activeBrand)
    )
      ? brands.find((brand) => parseInt(brand.ID) === parseInt(activeBrand))
          .brandType
      : brands.length > 0
      ? brands[0].brandType
      : "",
  };

  function getBrands(brands, permissions) {
    var brandList = [];

    for (const brand of brands) {
      brandList.push({
        ID: brand.brand_id,
        about: brand.about,
        brandName: brand.brand_name,
        logo: brand.logo,
        languages: brand.languages,
        locations: brand.audience_location,
        category: brand.site_category,
        mau: brand.mau,
        onlineStore: brand.online_store,
        website: brand.website,
        socialMedia: brand.social_media_handles,
        brandType: brand.brand_type_id,
      });
    }

    return brandList;
  }
}
